import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { AdminService } from '@app/services/admin.service';
import { Constants } from '@app/shared-module/constants';
import { GlobalResponse } from '@app/shared-module/models';
import { UpdateDoctorSubscription } from '@app/shared-module/models/admin/update-doctor-subscription';
import { IMyDateModel, IMyDpOptions } from 'mydatepicker';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-update-doctor-subscription',
  templateUrl: './update-doctor-subscription.component.html',
  styleUrls: ['./update-doctor-subscription.component.css']
})
export class UpdateDoctorSubscriptionDialogComponent implements OnInit {
  public headerTitle: string;
  public subscriptionData: any;
  public doctor_id: string;
  plan: string;
  paymentDate: any;
  paidAmount: number;
  // maxDoctors: number;
  activeDoctors: number;
  status_change: string;
  status_data: string;
  current_date: any = new Date();
  payRefNo: string;
  @BlockUI() blockUI: NgBlockUI;
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    editableDateField: false,
    openSelectorOnInputClick: true,
    showClearDateBtn: true,
    // disableUntil: { year: this.current_date.getFullYear(), month: this.current_date.getMonth() + 1, day: this.current_date.getDate() }
  };
  constructor(
    public dialogRef: MatDialogRef<UpdateDoctorSubscriptionDialogComponent>,
    private service: AdminService,
    private toastr: ToastrService,
    public datepipe: DatePipe
  ) { }

  ngOnInit() {
    if (this.subscriptionData) {
      this.pay_date(this.subscriptionData.payment_details.payment_date);
      this.plan = this.subscriptionData.plan._id ? this.subscriptionData.plan._id : '';
      this.payRefNo = this.subscriptionData.payment_details.payment_reference_no ? this.subscriptionData.payment_details.payment_reference_no : '';
      this.paidAmount = this.subscriptionData.paid_amount >= 0 ? this.subscriptionData.paid_amount : 0;
      this.activeDoctors = this.subscriptionData.active_doctors >= 0 ? this.subscriptionData.active_doctors : 0;
      // this.maxDoctors = this.subscriptionData.max_doctors >= 0 ? this.subscriptionData.max_doctors : 0;
      this.status_change = this.subscriptionData.status_change ? this.subscriptionData.status_change : '';
    }
  }

  updateItem() {
    let pay_date;
    if (this.paymentDate) {
      if (this.paymentDate.formatted) {
        pay_date = this.paymentDate.formatted;
      } else if (this.subscriptionData.payment_details.payment_date) {
        const pay_new_date = new Date(this.subscriptionData.payment_details.payment_date);
        pay_date = this.datepipe.transform(pay_new_date, 'dd/MM/yyyy');
      }
    }
    const maxDoctors = (this.plan === '5ece9ceabac44142faa1cbeb') ? 1 : 5;
    if (this.plan && this.plan !== '' &&
      this.payRefNo && this.payRefNo.length > 0 &&
      pay_date &&
      this.paidAmount && this.paidAmount >= 0 &&
      // this.maxDoctors && this.maxDoctors >= 0 &&
      this.status_change && this.status_change.length > 0) {
      // if (this.maxDoctors >= this.activeDoctors) {
      const subcriptionItem: UpdateDoctorSubscription = {
        paymentReferenceNo: this.payRefNo,
        paymentDate: pay_date,
        paidAmount: this.paidAmount,
        maxDoctors,
        statusChange: this.status_change,
        plan: this.plan
      };
      this.blockUI.start();
      this.service.updateDoctorSubscription(subcriptionItem, this.doctor_id).subscribe((res: GlobalResponse) => {
        this.blockUI.stop();
        if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
          this.dialogRef.close(res.result);
        }
      });
      // } else {
      //   this.toastr.error('Max doctors cannot exceed active doctors');
      // }
    } else {
      this.toastr.error('Please enter all the fields');
    }
  }
  onPaymentDateChanged = (event: IMyDateModel) => {
    this.paymentDate = event.formatted;
  }
  pay_date(paymentDate: string) {
    const payDate = new Date(paymentDate);
    const dd = payDate.getDate();
    const mm = payDate.getMonth() + 1;
    const yyyy = payDate.getFullYear();
    this.paymentDate = { date: { year: yyyy, month: mm, day: dd } };
  }
}
